/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReplaceHomeHealthPractitionerAssignmentRole } from './ReplaceHomeHealthPractitionerAssignmentRole';
import {
    ReplaceHomeHealthPractitionerAssignmentRoleFromJSON,
    ReplaceHomeHealthPractitionerAssignmentRoleFromJSONTyped,
    ReplaceHomeHealthPractitionerAssignmentRoleToJSON,
    ReplaceHomeHealthPractitionerAssignmentRoleToJSONTyped,
} from './ReplaceHomeHealthPractitionerAssignmentRole';

/**
 * 
 * @export
 * @interface ReplaceHomeHealthPractitionerAssignmentsRequest
 */
export interface ReplaceHomeHealthPractitionerAssignmentsRequest {
    /**
     * The 4 canonical roles plus the unassigned role.
     */
    roles: Array<ReplaceHomeHealthPractitionerAssignmentRole>;
}

/**
 * Check if a given object implements the ReplaceHomeHealthPractitionerAssignmentsRequest interface.
 */
export function instanceOfReplaceHomeHealthPractitionerAssignmentsRequest(value: object): value is ReplaceHomeHealthPractitionerAssignmentsRequest {
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function ReplaceHomeHealthPractitionerAssignmentsRequestFromJSON(json: any): ReplaceHomeHealthPractitionerAssignmentsRequest {
    return ReplaceHomeHealthPractitionerAssignmentsRequestFromJSONTyped(json, false);
}

export function ReplaceHomeHealthPractitionerAssignmentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceHomeHealthPractitionerAssignmentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': ((json['roles'] as Array<any>).map(ReplaceHomeHealthPractitionerAssignmentRoleFromJSON)),
    };
}

export function ReplaceHomeHealthPractitionerAssignmentsRequestToJSON(json: any): ReplaceHomeHealthPractitionerAssignmentsRequest {
    return ReplaceHomeHealthPractitionerAssignmentsRequestToJSONTyped(json, false);
}

export function ReplaceHomeHealthPractitionerAssignmentsRequestToJSONTyped(value?: ReplaceHomeHealthPractitionerAssignmentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roles': ((value['roles'] as Array<any>).map(ReplaceHomeHealthPractitionerAssignmentRoleToJSON)),
    };
}

